import React, { useEffect, useMemo, useState } from "react";
// import AdminImg from '../../Img/usrpict.PNG';
import { RiEditBoxFill, RiFileEditFill } from "react-icons/ri";
import AdminImg from "../../Img/viewer.png";
// import Viewer from '../../Img/viewer.png'
// import campraImg from "../../Img/LOGORepository.png"
import campraImg from "../../Img/logo.png";
import remove from "../../Img/delete.png";
import edit from "../../Img/edit.png";
import CategoryList from "./CategoryList";
// <<<<<<< HEAD
import back from "../../Img/new home.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Spinner from "../Spinner";
import { toast } from "react-toastify";
import Viewer from "../../Img/viewer.png";
import myarticles from "../../Img/new article.png";
import { Dropdown, Modal } from "react-bootstrap";
import TopNavBar from "../TopNavBar";
import SideBar from "../SideBar";
import { API_BASE_URL } from "../../utils/config";
import { MdDeleteForever } from "react-icons/md";
import { MDBDataTable } from "mdbreact";
import { FaImage, FaUserEdit } from "react-icons/fa";
import { IoEye } from "react-icons/io5";
import ImportArticleImage from "../../Img/import article.png";
import TransferAuthorImage from "../../Img/transfer author.png";
import CreateArticleImage from "../../Img/create article.png";
import EditFeatureImgage from "../../Img/edit featured image.png";
import UploadImage from "../../Img/upload featured.png";
import WordUploadImg from "../../Img/update.png";
import NewTopNavBar from "../NewTopNavBar";
const mammoth = require("mammoth/mammoth.browser");
// import mammoth from 'mammoth';
const cheerio = require("cheerio");
// =======
// import back from '../../Img/home_738822.png';
// >>>>>>> d8aaf382d53b54b6495407231a922f7960218c95

const TablePosts = () => {
  const [data, setData] = useState({ columns: [], rows: [] });
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(5);

  const dummyData = [
    { id: 1, name: "John Doe" },
    { id: 2, name: "Jane Doe" },
    { id: 3, name: "Alice" },
    { id: 4, name: "Bob" },
    { id: 5, name: "Charlie" },
    { id: 6, name: "David" },
    { id: 7, name: "Eve" },
    { id: 8, name: "Frank" },
    { id: 9, name: "Grace" },
    { id: 10, name: "Hank" },
    { id: 11, name: "Ivy" },
    { id: 12, name: "Jack" },
    { id: 13, name: "Kelly" },
    { id: 14, name: "Liam" },
    { id: 15, name: "Mia" },
  ];

  const fetchData = () => {
    setLoading(true);
    const start = (currentPage - 1) * perPage;
    const end = start + perPage;
    const slicedData = dummyData.slice(start, end);
    setData({
      columns: [
        { label: "ID", field: "id" },
        { label: "Name", field: "name" },
      ],
      rows: slicedData,
    });
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, perPage]);

  const handleStartClick = () => {
    setCurrentPage(1);
  };

  const handleEndClick = () => {
    setCurrentPage(Math.ceil(dummyData.length / perPage));
  };
  console.log(data);
  return (
    <div>
      <button onClick={handleStartClick}>Start</button>
      <button onClick={handleEndClick}>End</button>
      <MDBDataTable
        striped
        bordered
        hover
        data={data}
        paging={true}
        searchLabel="Search"
        paginationLabel={["Previous", "Next"]}
        entriesLabel="Show entries"
        infoLabel={["Showing", "to", "of", "entries"]}
        paginationPerPage={5}
        paginationRowsPerPageOptions={[5, 10, 20, 50]}
        noBottomColumns
        responsive
        pagination
        pagesAmount={Math.ceil(dummyData.length / perPage)}
        pagingTop
        pagingBottom
      />
    </div>
  );
};

export default TablePosts;
